import React from "react";
import { LucideCircleCheckBig } from "lucide-react";
import CommonTitle from "@/components/common/CommonTitle";
import CommonSubtitle from "@/components/common/CommonSubtitle";

export interface InfoSectionFeatureProps {
  id: number;
  title: string;
  description: string;
}
export interface InfoSectionProps {
  title: string;
  subtitle: string;
  featureArray: InfoSectionFeatureProps[];
}

const InfoSection = ({ title, subtitle, featureArray }: InfoSectionProps) => {
  return (
    <div className="container py-8 xs:pt-16 xl:pt-12">
      <div className="mx-auto">
        <div className="mx-auto max-w-[1100px] space-y-4 pb-5 text-center xl:px-20 xl:pb-16">
          <CommonTitle
            color="#202020"
            fontWeightClass="font-semibold"
            fontSizeClass="text-[26px] xl:text-[28px]"
          >
            {title}
          </CommonTitle>
          <CommonSubtitle
          >
            {subtitle}
          </CommonSubtitle>
        </div>
        <div className="mx-auto">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
            {featureArray.map((feature, index) => (
              <div
                key={index}
                className="relative rounded-[8px] border-l border-[#c0c0c0]"
              >
                <div className="h-full overflow-hidden rounded-[8px] bg-white">
                  <div className="flex h-full flex-col gap-5 rounded-lg p-6 xl:min-h-[120px] xl:justify-between xl:gap-2">
                    <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-b from-[#F4F1FF] to-white text-[24px] font-semibold text-[#313131]">
                      {feature.id}
                    </div>
                    <div className="flex flex-col gap-2">
                      <h3 className="text-[18px] lg:text-[20px] font-semibold text-[#202020]">
                        {feature.title}
                      </h3>
                      <p className="text-[14px] font-normal text-[#202020] xl:text-[16px]">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoSection;
